/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, intCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import { Select, Input, Button, InputNumber } from 'antd'
import {
  getWindGadsErrorMgmtInfo,
  postWindGadsErrorMgmtInfo,
  deleteWindGadsErrorMgmtInfo,
} from 'api/pgads.js'
import CommonScreen from 'admin/component/CommonScreen'
// import R from 'ramda'
import { severity } from 'core/utils'

const requiredField = () => <span style={{ color: 'red' }}>*</span>

const headers = [
  intCol({
    ident: 'errorcode',
    display: 'Error Code',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'severity',
    display: 'Severity',
    ...toSelectionColProps(severity),
    isRequired: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'error',
    display: 'Error',
    width: 950,
    alignment: 'left',
    isRequired: true,
    sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getWindGadsErrorMgmtInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postWindGadsErrorMgmtInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteWindGadsErrorMgmtInfo(apiTargetInfo)(data)

const title = 'Wind Error Management'

const WindGadsErrorMgmt = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  // const setData = data => {
  //   setInsertData({ ...insertData, ...data })
  // }

  // const onCancel = () => {
  //   setInsertEvent(false)
  // }

  // useEffect(() => {
  //   setInsertData({ severity: 0 })
  // }, [insertEvent])

  // const validateData = () => {
  //   // const { cards, errorcode, error ,fromField , toField , columnPlace } = insertData
  //   const { errorcode, error } = insertData
  //   if (errorcode === undefined) message.error('Please, Enter Error Code')
  //   else if (error === undefined) message.error('Please, Enter Error to Save')
  //   else return true
  // }

  // const onAdd = ({ hide, retrieve }) => {
  //   const validate = validateData()
  //   if (validate)
  //     modifyTask(props.apiTargetInfo)([insertData]).fork(setErr, _ => {
  //       message.info('Data Saved')
  //       setInsertEvent(!hide)
  //       setInsertData({ severity: 0 })
  //       retrieve && retrieve()
  //     })
  // }
  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td style={{ width: '100px', textAlign: 'right' }}>
              Error Code{requiredField()} :
            </td>
            <td style={{ width: '100px' }}>
              <InputNumber
                style={{ width: '100px' }}
                value={insertData.errorcode}
                min={0}
                maxLength={22}
                onChange={value =>
                  setInsertData({ ...insertData, errorcode: value })
                }
              />
            </td>

            <td style={{ width: '80px', textAlign: 'right' }}>Severity :</td>
            <td style={{ width: '100px' }}>
              <Select
                defaultValue={severity[insertData.severity]}
                style={{ width: '100px' }}
                onChange={value =>
                  setInsertData({ ...insertData, severity: value })
                }
              >
                {Object.keys(severity).map(m => (
                  <Select.Option key={m}>{severity[m]}</Select.Option>
                ))}
              </Select>
            </td>

            <td style={{ textAlign: 'right' }}>Error{requiredField()} :</td>
            <td colSpan={3}>
              <Input
                value={insertData.error}
                maxLength={500}
                onChange={e =>
                  setInsertData({ ...insertData, error: e.target.value })
                }
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.errorcode}
      autoRetrieve
      sortOptions={headers}
      insertComp={insertEvent && insertComp}
      insertCompHeight={80}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(WindGadsErrorMgmt)
